export const blockIconsUiactionsRefreshNew = (
	<span className='material-symbols-outlined'>refresh</span>
);
